import UseAxios from '../http/http';
import { serviceName } from '../resources/serviceConstants';
import {
  CHANGE_REQUEST,
  CHANGE_REQUEST_EDIT_FORM_OPTIONS,
  CHANGE_REQUEST_DETAILS,
  CHANGE_REQUEST_CREATE,
  CHANGE_REQUEST_APPROVE,
} from '../resources/endPoint';

const getAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  token: token || '',
  isAuthToken: true,
});

export const fetchCROption = ({ authToken, optionType, userInfo }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: `${CHANGE_REQUEST_EDIT_FORM_OPTIONS}/${optionType}`,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: { userInfo },
});

export const fetchCRDetails = ({ authToken, crId }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'get',
  url: `${CHANGE_REQUEST_DETAILS}/${crId}`,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
});

export const createChangeRequest = ({ authToken, payload }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: CHANGE_REQUEST_CREATE,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload,
});

export const updateChangeRequest = ({ authToken, crId, payload }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'put',
  url: `${CHANGE_REQUEST}/${crId}`,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload,
});

export const approveCRRequest = ({ authToken, crId, payload }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: `${CHANGE_REQUEST_APPROVE}/${crId}`,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload,
});
